import { render, staticRenderFns } from "./SchoolClassChip.vue?vue&type=template&id=3e3ffb20"
import script from "./SchoolClassChip.vue?vue&type=script&lang=js"
export * from "./SchoolClassChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports